{
  "UnifiedNavigation": "Experience Cloud 内を移動",
  "adobeExperienceCloudNoOrgsSelect": "別の組織アカウントを選択",
  "help": "ヘルプ",
  "profile": "プロファイル",
  "searchButton": "検索",
  "sidenavMenuCloseTooltip": "メニューを閉じる",
  "sidenavMenuOpenTooltip": "メニューを開く",
  "solutionSwitcher": "別のソリューションに切り替え",
  "toggleSideNav": "サイド・ナビゲーション・メニューを切り替え"
}
